(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-testimonials"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.testimonials-swiper', {
    slidesPerView: 2.1,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
